import React from 'react'

const Loader2 = () => {
    return (
        <div className="loader-wapper d-flex align-items-center justify-content-center">
            <div className="dotted-loader"></div>
            <img src="/img/favicon1.png" className="img-fluid" width="35" height="35" alt="loader-img1"></img>
        </div>
       
    )
}
export default Loader2;